import {makeStyles} from "@mui/styles";
import {useTheme} from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  navlinks: {
    marginLeft: useTheme().spacing(5),
    display: "flex",
    justifyContent:'center',
    alignItems:'center',
    fontFamily: ['JejuGothic', 'Roboto']
  },
  logo: {
    cursor: "pointer",
    color:'#fff',
    textDecoration: 'none',
    fontSize:'18px !important',
    // fontWeight:'bold',
    "&:hover": {
      // color: useTheme().palette.primary.main,
      opacity: 0.8
      // borderBottom: "1px solid white",
    },
    fontSize:'18px',
    fontFamily: "'JejuGothic', 'Roboto' !important"
  },
  logoImg: {
    "&:hover": {
      opacity:0.5
    },
  },
  link: {
    display:'flex',
    textDecoration: "none",
    // color: "#212121",
    color: "#fff",
    fontSize: "16px",
    marginLeft: useTheme().spacing(5),
    "&:hover": {
      opacity: 0.8
      // color: useTheme().palette.primary.main,
      // borderBottom: "1px solid white",
    },
    fontFamily: ['JejuGothic', 'Roboto']
    
  },
  userName: {
    textDecoration: "none",
    color: "#fff",
    fontSize: "16px",
    marginLeft: useTheme().spacing(5),
    cursor:'default',
    fontFamily: ['JejuGothic', 'Roboto']
  },
  schoolName: {
    textDecoration: "none",
    color: "#fafafa",
    // color: "#dfeaf8",
    // color: "#616161",
    // color: "#fff",
    fontSize: "24px !important",
    cursor:'default',
    fontFamily: ['JejuGothic', 'Roboto']
  },
  home: {
    textDecoration: "none",
    color: "#212121",
    fontSize: "16px",
    fontFamily: ['JejuGothic', 'Roboto']
  },
  sideMenu: {

  }
}));

export default useStyles
